import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
    ClientConfigService,
    CommonMessages,
    DeviceService,
    LoginNavigationService,
    NativeAppService,
    NavigationService,
    TrackingEventData,
} from '@frontend/vanilla/core';

import { CommonClientConfig, SpendingControlsClientConfig } from '../client-config/client-config.models';
import { NewAccountMenuService } from '../services/account-menu-v2.service';

@Injectable({
    providedIn: 'root',
})
export class CommonMethodsService {
    constructor(
        private navigationService: NavigationService,
        private nativeAppService: NativeAppService,
        private loginNavigationService: LoginNavigationService,
        private router: Router,
        private device: DeviceService,
        private newAccountMenuService: NewAccountMenuService,
        private spendingControlsClientConfig: SpendingControlsClientConfig,
        private commonConfig: CommonClientConfig,
        private clientConfig: ClientConfigService,
        private commonMessages: CommonMessages,
    ) {}

    goToLastKnownProduct() {
        if (this.nativeAppService.isNative) {
            this.loginNavigationService.goToHome();
        } else {
            this.navigationService.goToLastKnownProduct();
        }
    }

    getActiveSpendingControlsIndex() {
        if (this.device.isMobilePhone)
            return document.getElementsByClassName('nav-item spendingcontrol active')![0]?.getAttribute('data-tabid') as string;
        else if (
            this.newAccountMenuService.isNewAccountMenu() &&
            document.getElementsByClassName('navigation-layout-nav-items') &&
            document.getElementsByClassName('navigation-layout-nav-items')![0]?.children
        )
            return (
                Array.prototype.slice
                    .call(document.getElementsByClassName('navigation-layout-nav-items')![0]?.children)
                    .indexOf(document.getElementsByClassName('nav-item active')![0]) + 1
            );
    }

    isInSpendingControls(): boolean {
        const inSpendingControls = this.router.url.indexOf('spendingcontrols') > -1;
        return (
            inSpendingControls ||
            (this.spendingControlsClientConfig.spendingControlsEnabled && this.newAccountMenuService.isNewAccountMenu() && !inSpendingControls)
        );
    }

    getSegmentedClassName(length: number) {
        if (length == 2) return 'form-control-tabs-segmented-v2';
        else if (length == 3) return 'form-control-tabs-segmented-v2 three-tabs';
        else if (length == 4) return 'form-control-tabs-segmented-v2 four-tabs';
        else return ' ';
    }

    loadClientConfig(clientConfig: any[]) {
        return this.clientConfig.load('', clientConfig);
    }

    getGuideConfig() {
        return {
            guideVIPUser: this.commonConfig.guideConfig,
            guideEnabled: this.commonConfig.guideEnabled,
            enableGreeceComplaintForm: this.commonConfig.enableGreeceComplaintForm,
            showContactOptionsBySource: this.commonConfig.showContactOptionsBySource,
            landingPage: this.commonConfig.landingPage,
            enableFullPageRedirection: this.commonConfig.enableFullPageRedirection,
        };
    }

    loadSkeleton(key: any, id: any) {
        if (this.commonConfig.enableSkeleton) {
            if ((key == 'HCCSkeleton' && window.location.href.indexOf('documentupload') > -1) || window.location.href.indexOf('twofa') > -1) {
                return;
            }
            const tempWrapper = document.createElement('div');
            tempWrapper.innerHTML =
                key == 'GCHomePage'
                    ? this.commonConfig.isGcRedesignEnabled
                        ? this.commonMessages['GCSkeletonRedesign']
                        : this.commonMessages['GCSkeleton']
                    : this.commonMessages['' + key];
            tempWrapper.className = 'navigation-layout-page';
            tempWrapper.id = id;
            document.getElementById('main-content')?.appendChild(tempWrapper);
        }
    }
    hideLoader() {
        if (document.getElementsByTagName('vn-loading-indicator')[0]) {
            if (document.getElementsByTagName('vn-loading-indicator')[0].querySelector('.loading')) {
                document.getElementsByTagName('vn-loading-indicator')[0].querySelector('.loading')?.setAttribute('hidden', 'true');
            }
        }
    }
    confirmPopupTrackLoadAndClick(LableEvent: string, LocationEvent: string, eventName: string) {
        let trackData: TrackingEventData = {
            eventName: eventName,
            data: {
                'component.CategoryEvent': 'gambling controls',
                'component.ActionEvent': eventName == 'contentView' ? 'load' : 'click',
                'component.LabelEvent': LableEvent,
                'component.PositionEvent': 'exit confirmation popup',
                'component.LocationEvent': LocationEvent,
                'component.EventDetails': eventName == 'contentView' ? 'exit confirmation popup' : '',
                'component.URLClicked': 'not applicable',
            },
        };
        return trackData;
    }

    trackBackAndClose(LabelEvent: string, ActionEvent: string, EventDetails: string) {
        let trackData: TrackingEventData = {
            eventName: 'Event.Tracking',
            data: {
                'component.CategoryEvent': 'gambling controls',
                'component.LabelEvent': LabelEvent,
                'component.URLClicked': 'not applicable',
                'component.ActionEvent': ActionEvent,
                'component.PositionEvent': 'not applicable',
                'component.LocationEvent': LabelEvent,
                'component.EventDetails': EventDetails,
            },
        };
        return trackData;
    }
}
